import { Component, inject } from '@angular/core';
import { RegisterPerPropertyService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  RegisterPerPropertyCreateDto,
  RegisterPerPropertyDto,
  RegisterPerPropertyExcelDownloadDto,
  RegisterPerPropertyUpdateDto,
} from '../proxy/planning/dtos/register-per-property';
import { REGISTERPERPROPERTY_CONFIG, REGISTERPERPROPERTY_FIELDS } from './register-per-property.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-register-per-property',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, RegisterPerPropertyService, ConfirmationService],
  templateUrl: './register-per-property.html',
  styleUrl: './register-per-property.scss',
})
export class RegisterPerProperty extends BaseCrudComponent<
  RegisterPerPropertyDto,
  RegisterPerPropertyCreateDto,
  RegisterPerPropertyUpdateDto,
  RegisterPerPropertyExcelDownloadDto
> {
  service = inject(RegisterPerPropertyService);
  config = REGISTERPERPROPERTY_CONFIG;
  fields = REGISTERPERPROPERTY_FIELDS;

  protected prepareUpdateDto(data: any, selected: RegisterPerPropertyDto): RegisterPerPropertyUpdateDto {
    return {
      registerId: data.registerId,
      propertyId: data.propertyId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'RegisterPerProperty';
  }
}
